import { lazy } from "react";

export const Home = lazy(() => import("../pages/dashboard/home/index"));
export const Reporting = lazy(() => import("../pages/dashboard/reporting"));
export const Desktop = lazy(() => import("../pages/dashboard/desktop-app"));
export const Solutions = lazy(() => import("../pages/dashboard/solutions"));

export const AutomationLabs = lazy(
  () =>
    import(
      "../pages/dashboard/solutions/pages/automation-solutions/automation-services"
    )
);
export const TechMentor = lazy(
  () =>
    import(
      "../pages/dashboard/solutions/pages/support-and-expertise/tech-mentor"
    )
);
export const SystemBridge = lazy(
  () =>
    import(
      "../pages/dashboard/solutions/pages/automation-solutions/workflow-automation"
    )
);

export const OutageHub = lazy(
  () =>
    import(
      "../pages/dashboard/solutions/pages/support-and-expertise/outage-hub/"
    )
);
export const Troubleshooting = lazy(
  () =>
    import(
      "../pages/dashboard/solutions/pages/support-and-expertise/troubleshooting"
    )
);

export const ProjectExecution = lazy(
  () =>
    import(
      "../pages/dashboard/solutions/pages/project-and-knowledge/project-execution"
    )
);
export const ActualIntelligence = lazy(
  () =>
    import(
      "../pages/dashboard/solutions/pages/project-and-knowledge/actual-intelligence"
    )
);
export const Onboarding = lazy(
  () =>
    import(
      "../pages/dashboard/solutions/pages/project-and-knowledge/onboarding"
    )
);

export const VendorOps = lazy(
  () => import("../pages/vendor-atlas-ui")
);

export const ClientIntelligence = lazy(
  () =>
    import(
      "../pages/dashboard/solutions/pages/operations/client-intelligence"
    )
);

export const LifecycleNavigator = lazy(
  () =>
    import(
      "../pages/dashboard/solutions/pages/projects-and-people/employee-lifecycle"
    )
);

export const Integrations = lazy(
  () => import("../pages/dashboard/integrations")
);
export const Portal = lazy(() => import("../pages/dashboard/portal"));
export const Perspectives = lazy(() => import("../pages/dashboard/perspectives"));
export const Roadmap = lazy(() => import("../pages/dashboard/roadmap"));
export const Feedback = lazy(() => import("../pages/dashboard/feedback"));
export const Sweepstakes = lazy(() => import("../pages/dashboard/sweepstakes"));
export const Investments = lazy(() => import("../pages/dashboard/investments"));
export const OAuthCallback = lazy(() => import("../pages/auth/oauth-callback"));
export const Settings = lazy(() => import("../pages/dashboard/settings"));

export const Walkthrough = lazy(() => import("../pages/dashboard/walkthrough"));
export const SystemMap = lazy(() => import("../pages/dashboard/system-map"));
export const HowItWorks = lazy(
  () => import("../pages/dashboard/research/how-it-works")
);
export const Participation = lazy(
  () => import("../pages/dashboard/research/participation")
);
